import {Types} from "../actions/auditLogActions";
import _ from "lodash";

const auditLogReducers = (state, action) => {

  console.log('action.type',action)

  switch (action.type) {
    case Types.AUDIT_LOG_VIEW_DETAIL: {

      let newState = _.cloneDeep(state);

      newState.auditLogs = {
        ...state.auditLogs,
        detailView: action.show ? action.item : action.show
      }

      return newState;
    }
    default:
      return state;
  }
};

export default auditLogReducers;